<template>
    <div class="modal coupon_rule_modal fade" v-bind:class="{in: isShowModal, active: isShow}">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-body">
                    <p class="rcclConfirm-title">温馨提示</p>
                    <div class="rcclConfirm-content"><span>我已阅读<a href="/content/rewardprivacy_PC" class="privacyLink external" target="_blank">《“皇家游享荟”项目细则》</a>并同意注册“皇家游享荟”会员及接受会员相关的优惠资讯及推送消息</span></div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" @click="cancel">取消</button>
                    <button type="button" class="btn btn-primary" @click="ok">确定</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '@/api'
    import { delayDev } from '@/utilities/tools'

    export default {
        name: 'SignUpRewardConfirm',
        props: {},
        data: () => {
            return {
                isShow: false,
                isShowModal: false,
            }
        },
        watch: {
            isShow (newVal) {
                if (newVal) {
                    delayDev(100, () => {
                        this.isShowModal = true
                    })
                } else {
                    this.isShowModal = false
                }
            }
        },
        methods: {
            show () {
                this.isShow = true
                document.body.style.overflow = 'hidden'
            },
            cancel () {
                this.isShow = false
                document.body.style.overflow = 'auto'
                this.$emit('on-cancel')
            },
            async ok () {
                this.$loading.show()
                const { errMsg, success } = await api.user.signInReward()
                this.$loading.hide()
                if (success) {
                    this.$emit('on-confirm', true)
                } else {
                    this.$alert.show(errMsg)
                    delayDev(1000, () => {
                        window.location.href = `/Rccl.Campaign/MemberCenter/Auth?redirectUrl=${encodeURIComponent(`${process.env.VUE_APP_REWARD_URL}/rewardpc/member/index`)}`
                    })
                }
                this.isShow = false
            },
            close () {
                this.isShow = false
                this.$emit('on-confirm')
            },
        }
    }
</script>

<style lang="less" scoped>
    .coupon_rule_modal {
        background-color: rgba(0,0,0,0.5);
        &.active {
            display: block;
        }
        .modal-dialog {
            top: 40px;
        }
        .modal-body {
            position: relative;
            padding: 15px;
            .rcclConfirm-title{
                margin-top: 23px;
                text-align: center;
                font-size: 20px;
                color: #006ab9;
                font-weight: bold;
                margin-bottom: 30px;
            }
            .rcclConfirm-content {
                font-size: 14px;
                color: #747d80;
                padding: 0 35px;
                text-align: left;
                line-height: 20px;
                a {
                    color: #337ab7;
                    text-decoration: none;
                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
        }
        .modal-footer {
            padding: 25px 15px 50px 15px;
            text-align: center;
            border-top: none;
            .btn,
            .btn:hover,
            .btn:focus{
                color: #282b2c;
                background-color: white;
                border: solid 1px #d3dadd;
            }
            .btn-primary,
            .btn-primary:hover,
            .btn-primary:focus {
                background-color: #fcc301;
                border-color: #fcc301;
            }
        }

    }
</style>
